import { ShoppingCartStoreMutations } from "../shoppingCart";
import { VoipNumberPoolStoreMutations } from "../voipNumberPool";
import { GENERIC_SALE_PROCESS_CLEAR_STATE } from "./constants";

const clear = ({ commit }: any) => {
	commit(GENERIC_SALE_PROCESS_CLEAR_STATE);

	commit(ShoppingCartStoreMutations.CLEAR, null, { root: true });
	commit(VoipNumberPoolStoreMutations.CLEAR, null, { root: true });
};

export default {
	[GENERIC_SALE_PROCESS_CLEAR_STATE]: clear
};
